/* Studio VormVezel – gedrag voor Over ons (templates/page.over-ons.json, secties vv-about-*). Geen afhankelijkheden.
   Wordt door layout/vv.liquid na vv.js geladen. Hooks:
   - Ankers: elke sectie heeft een id (ons-verhaal, zo-maken-we-het, samenwerkingen, samenwerken, reviews, kom-langs,
     bedrijfsgegevens). /pages/over-ons#samenwerkingen werkt zonder script; dit script zet daarna de focus op de kop.
   - Oude demo-links /pages/over-ons?sectie=samenwerkingen: scrollen naar dat blok en de adresbalk wordt …#samenwerkingen.
   - Links naar een blok op deze pagina (ook vanuit het menu): menu sluiten, soepel scrollen, focus op de kop.
   - a[data-scroll] (scrollen doet vv.js): het anker komt in de adresbalk, zodat je de link kunt delen.
   - Markt-kaart: [data-oo-markt-card][data-oo-markt-src] haalt (als de sectie bijna in beeld is) de homepage op en neemt
     de kaart van de sectie "Volgende markt" over ([data-vv-market][data-date] .nt); de agendaknop daarin krijgt de link uit
     [data-oo-markt-agenda]. Lukt dat niet, of is de kaart verlopen (vv.js verbergt [data-vv-market][data-date]), dan
     blijft/komt [data-oo-markt-fallback] (knop naar de agenda). "Vandaag"/"Morgen" wordt opnieuw bepaald via
     p[data-vv-market-label][data-label][data-today][data-tomorrow]. */
(function () {
  'use strict';
  var D = document;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var HEADS = 'h1[tabindex],h2[tabindex],h3[tabindex]';

  /* ---------- Ankers ---------- */
  function target(id) {
    if (!id || !/^[a-z0-9][a-z0-9_-]*$/i.test(id)) return null;
    var el = D.getElementById(id), main = $('#main');
    return el && (!main || main.contains(el)) ? el : null;
  }
  function focusHeading(el) {
    var h = (el.matches && el.matches(HEADS)) ? el : el.querySelector(HEADS);
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
  }
  function go(el, smooth) {
    try { el.scrollIntoView({ behavior: smooth && !reduced ? 'smooth' : 'auto', block: 'start' }); } catch (e) { el.scrollIntoView(true); }
    focusHeading(el);
  }
  function sectieParam(search) {
    var m = /[?&]sectie=([^&#]+)/.exec(search || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return ''; }
  }
  function hashId(hash) {
    try { return decodeURIComponent((hash || '').replace(/^#/, '')); } catch (e) { return ''; }
  }
  /* Zoekparameters zonder sectie=… (bijv. ?preview_theme_id=… blijft staan) */
  function cleanSearch(search) {
    return (search || '').replace(/([?&])sectie=[^&#]*&?/, '$1').replace(/[?&]$/, '');
  }
  /* Anker in de adresbalk als nieuwe stap in de geschiedenis (zoals de demo met #/…?sectie=), zodat 'terug' weer
     bovenaan uitkomt. Staat hetzelfde anker er al, dan geen dubbele stap. */
  function pushHash(id, search) {
    if (location.hash === '#' + id && search === location.search) return;
    try { history.pushState(history.state, '', location.pathname + search + '#' + id); } catch (x) {}
  }
  /* Open lades/panelen (menu) sluiten via vv.js; geeft true als er iets dicht ging */
  function closePanels() {
    var n = 0, site = $('#site');
    if (!window.vv || typeof window.vv.closeTop !== 'function') return false;
    while (site && site.inert && n < 6) { window.vv.closeTop(); n++; }
    return n > 0;
  }

  /* De browser zet de focus tijdens het laden soms terug op <body> (bijv. als hij zelf naar het #anker springt).
     Na 'load' nog één keer de kop focussen, maar alleen als de bezoeker intussen nergens anders op staat. */
  function focusAfterLoad(el) {
    if (D.readyState === 'complete') return;
    window.addEventListener('load', function () {
      var a = D.activeElement;
      if (D.documentElement.contains(el) && (!a || a === D.body || a === D.documentElement)) focusHeading(el);
    });
  }

  /* Binnenkomen met ?sectie=… (oude links) of #… */
  (function () {
    var id = sectieParam(location.search), el = target(id);
    if (el) {
      try { history.replaceState(history.state, '', location.pathname + cleanSearch(location.search) + '#' + id); } catch (e) {}
      setTimeout(function () { go(el, false); }, 30);
      focusAfterLoad(el);
      return;
    }
    el = target(hashId(location.hash));
    if (el) { focusHeading(el); focusAfterLoad(el); }
  })();

  /* Ander anker in de adresbalk (bijv. terug-knop of gewone #-link): focus op de kop */
  window.addEventListener('hashchange', function () { var el = target(hashId(location.hash)); if (el) focusHeading(el); });

  /* Links naar een blok op deze pagina, ook uit het menu of de footer */
  D.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('data-scroll') || a.hasAttribute('data-open') || (a.target && a.target !== '_self')) return;
    var url; try { url = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (url.origin !== location.origin || url.pathname.replace(/\/+$/, '') !== location.pathname.replace(/\/+$/, '')) return;
    /* Andere weergave van dezelfde pagina (bijv. ?view=markten) is een andere pagina: niet onderscheppen */
    var ls = cleanSearch(location.search), us = cleanSearch(url.search);
    if (us && us !== ls) return;
    var id = sectieParam(url.search) || hashId(url.hash), el = target(id);
    if (!el) return;
    e.preventDefault();
    var closed = closePanels();
    pushHash(id, ls);
    setTimeout(function () { go(el, true); }, closed ? 60 : 0);
  });

  /* a[data-scroll]: vv.js scrolt en zet de focus; wij zetten het anker in de adresbalk (deelbare link, 'terug' werkt) */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-scroll]'); if (!a) return;
    var id = a.getAttribute('data-scroll'); if (!target(id)) return;
    pushHash(id, cleanSearch(location.search));
  });

  /* ---------- Markt-kaart (Kom langs op de markt) ---------- */
  function todayISO() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function isoPlus(days) {
    var d = new Date(); d.setDate(d.getDate() + days);
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function setFallback(card, on) {
    var fb = card.parentNode ? $('[data-oo-markt-fallback]', card.parentNode) : null;
    if (fb) fb.hidden = !on;
  }
  /* "Vandaag" / "Morgen" opnieuw bepalen (de pagina kan uit de cache komen): p[data-vv-market-label] */
  function dayLabel(card) {
    var p = $('[data-vv-market-label]', card), dt = card.getAttribute('data-date');
    if (!p || !dt) return;
    var base = p.getAttribute('data-label') || '', word = '';
    if (dt === todayISO()) word = p.getAttribute('data-today') || '';
    else if (dt === isoPlus(1)) word = p.getAttribute('data-tomorrow') || '';
    p.textContent = base;
    if (word) {
      if (base) p.appendChild(D.createTextNode(' · '));
      var b = D.createElement('b'); b.textContent = word; p.appendChild(b);
    }
    p.hidden = !base && !word;
  }
  function initMarket(root) {
    $$('[data-oo-markt-card]', root).forEach(function (card) {
      if (card._oo) return; card._oo = true;
      var src = card.getAttribute('data-oo-markt-src');
      if (!src) {
        /* Kaart uit deze sectie zelf: verlopen (door vv.js verborgen of datum voorbij) → knop naar de agenda */
        var dt = card.getAttribute('data-date');
        if (card.hidden || (dt && dt < todayISO())) { card.hidden = true; setFallback(card, true); }
        else dayLabel(card);
        return;
      }
      if (!window.fetch || !window.DOMParser) return;
      /* Pas ophalen als de sectie bijna in beeld is (scheelt een verzoek voor wie niet zo ver scrolt) */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es.some(function (en) { return en.isIntersecting; })) { io.disconnect(); loadHomeMarket(card, src); }
        }, { rootMargin: '800px 0px' });
        io.observe(card.parentNode || card);
      } else loadHomeMarket(card, src);
    });
  }
  /* De homepage ophalen en de kaart uit de sectie "Volgende markt" overnemen ([data-vv-market][data-date] .nt) */
  var homeReq = null;
  function loadHomeMarket(card, src) {
    homeReq = homeReq || fetch(src, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
    homeReq.then(function (html) {
      /* DOMParser laadt geen foto's of video's uit de opgehaalde HTML */
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var today = todayISO(), nt = null, date = '';
      $$('[data-vv-market][data-date]', doc).some(function (sec) {
        var d = sec.getAttribute('data-date'), n = sec.classList.contains('nt') ? sec : sec.querySelector('.nt');
        if (d && d >= today && n) { nt = n; date = d; return true; }
        return false;
      });
      if (!nt) return;
      if (!D.documentElement.contains(card)) return; /* sectie is intussen opnieuw geladen (thema-editor) */
      card.innerHTML = nt.innerHTML;
      $$('[id]', card).forEach(function (x) { x.removeAttribute('id'); }); /* geen dubbele id's */
      card.setAttribute('data-vv-market', '');
      card.setAttribute('data-date', date);
      /* Knop "Bekijk de agenda" naar de agenda van deze pagina (zelfde als de terugvalknop) */
      var ag = card.getAttribute('data-oo-markt-agenda'), btn = $('.nt-acts .btn', card);
      if (ag && btn) btn.setAttribute('href', ag);
      dayLabel(card);
      card.hidden = false;
      setFallback(card, false);
    }).catch(function () { homeReq = null; /* terugval-knop blijft staan */ });
  }
  initMarket(D);

  /* ---------- Thema-editor: sectie opnieuw geladen ---------- */
  D.addEventListener('shopify:section:load', function (e) { initMarket(e.target); });
})();
